import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DigitalBadgePublishedDisplayModelWithOverview } from '../../model/VideoCourses/DigitalBadgePublishedDisplayModelWithOverview';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { CoursewareService } from 'src/services/CoursewareService';
import { ActivatedRoute, Router } from '@angular/router';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { globals } from '../shared/globals';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { EmbedVideoService } from 'ngx-embed-video';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';
import { TextUtils } from '../shared/textutil';
import { json } from 'body-parser';

@Component({
  selector: 'app-videocoursecontent',
  templateUrl: './videocoursecontent.component.html',
  styleUrls: ['./videocoursecontent.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class VideocoursecontentComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() content: DigitalBadgePublishedDisplayModelWithOverview;
  private displayOverview: boolean = true;
  private displayFaqs: boolean = false;
  private showMore: boolean = false;
  public breadcrumbs: Breadcrumb[] = [];
  theVideoUrl: any;
  overviewHTML: TextUtils = null;
  faqsHtml: TextUtils = null;
  faqsTitle: string = null;

  constructor(private canonicalService: MetaService, private embedService: EmbedVideoService, private titleService: Title, private _router: Router, private route: ActivatedRoute, private coursewareService: CoursewareService, private sanitizer: DomSanitizer, private alertService: AlertService) {
    super();
  }

  public getTheVideoUrl() {
    this.theVideoUrl = this.embedService.embed_vimeo(this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.VideoID.ID);
  }

  public getEntryImageUrl(ThumbnailFileName) {
    return this.sanitizer.bypassSecurityTrustResourceUrl("/assets/databaseimages/" + ThumbnailFileName);
  }

  public getTheUrl() {
    return globals.LOCALHOST + this._router.url + "/";
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  ngOnInit() {
    this.displayOverview = true;
    this.displayFaqs = false;
    this.showMore = false;

    let alias = this.route.snapshot.paramMap.get('alias');

    this.coursewareService.getVideocoursesData(globals.token, alias).subscribe(data => {
      this.content = data;
      //  console.log("data is " + JSON.stringify(data));
      if (!this.content)
        console.log("this.content is null");
      else if (!this.content.digitalBadgePublishedDisplayModel) {
        console.log("this.content.digitalBadgePublishedDisplayModel is null");
      }
      this.overviewHTML = new TextUtils(this.content.digitalBadgePublishedDisplayModel.Summary);
      this.faqsHtml = new TextUtils(this.content.digitalBadgeOverviewData.faqs[1].Description);
      this.faqsTitle = this.content.digitalBadgeOverviewData.faqs[1].EntryTitle;
      if (!this.content.digitalBadgeOverviewData) {
        this.content = null;
        let error: Error = data;
        this.alertService.error(error.Message);
        return;
      }
      let theUrl = this.getTheUrl();

      this.getTheVideoUrl();
      this.canonicalService.addMetaTags(theUrl,
        this.content.digitalBadgePublishedDisplayModel.Summary,
        this.content.digitalBadgePublishedDisplayModel.LogoUrl,
        this.content.digitalBadgePublishedDisplayModel.Title,
        this.content.digitalBadgePublishedDisplayModel.FacebookAppId);

      this.titleService.setTitle(this.content.digitalBadgePublishedDisplayModel.Title);
      this.canonicalService.createCanonicalURL(this._router.url, "/videocoursescontentview/" + this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.Information.Alias);

      this.breadcrumbs = [{ Title: "Video-Courses", URL: "/videocoursesview" }, { Title: this.content.digitalBadgePublishedDisplayModel.Lineage[0].TopicInformation.Title, URL: "/videocoursesview/" + this.content.digitalBadgePublishedDisplayModel.Lineage[0].TopicInformation.Alias }, { Title: this.content.digitalBadgePublishedDisplayModel.Title, URL: "/videocoursesview/" + this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.Information.Alias }];
      this.pushAllAds(2);

    });
  }

  showSubscribe() {
    if (this.content && !this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.LicensedByUser && !this.content.HasAccess)
      return true;
    return false;
  }

  isLoggedIn() {
    if (globals.userName)
      return true;
    return false;
  }

  getDisplayFaqsButton() {
    if (this.displayFaqs)
      return 'btn btn-block selected-digital-badge-overview-buttons';
    return 'btn btn-block digital-badge-overview-buttons';
  }

  getDisplayOverviewButton() {
    if (this.displayOverview)
      return 'btn btn-block selected-digital-badge-overview-buttons';
    return 'btn btn-block digital-badge-overview-buttons';
  }

  getOverviewHtmlPart1() {
    if (this.overviewHTML == null) {
      return this.sanitizer.bypassSecurityTrustHtml("");
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.overviewHTML.firstHalf);
  }

  getFaqsHtmlPart1() {
    if (this.faqsHtml == null) {
      return this.sanitizer.bypassSecurityTrustHtml("");
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.faqsHtml.firstHalf);
  }

  getOverviewHtmlPart2() {
    if (this.overviewHTML == null) {
      return this.sanitizer.bypassSecurityTrustHtml("");
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.overviewHTML.secondHalf);
  }

  getFaqsHtmlPart2() {
    if (this.faqsHtml == null) {
      return this.sanitizer.bypassSecurityTrustHtml("");
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.faqsHtml.secondHalf);
  }

  showTest(alias, parentId) {
    this._router.navigate(["/videocoursesmoduleview", this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.Information.Alias]);
    return false;
  }

  showFinal(alias, ) {
    this._router.navigate(["/examview", this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.Information.Alias, JSON.stringify(this.breadcrumbs)]);
    return false;
  }

  showNothing() {
    if (this.showSubscribe)
      return false;
    if (this.content && this.content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.LicensedByUser)
      return true;
    return false;
  }

  showLicensed() {
    if (this.showSubscribe || this.showNothing)
      return false;
    if (this.content && this.content.digitalBadgePublishedDisplayModel.PassedExam)
      return true;
    return false;
  }

  showPassedExam() {
    if (this.content && this.content.digitalBadgePublishedDisplayModel && this.content.digitalBadgePublishedDisplayModel.PassedExam)
      return true;
    return false;
  }

}